<template>
  <nav class="navbar navbar-expand-lg luxury-navbar sticky-top animate-nav-entry">
    <div class="container navbar-box">
      <router-link class="navbar-brand" to="/">
        <img src="@/assets/images/logo.png" alt="Logo" class="nav-logo"/>
      </router-link>

      <div class="d-flex align-items-center gap-3 d-lg-none">
        <div v-if="isAuthenticated" class="position-relative">
          <div class="mini-profile-trigger" @click.stop="toggleProfileDropdown">
            <img v-if="userAvatar" :src="userAvatar" class="avatar-circle-sm shadow-sm" />
            <div v-else class="avatar-letter-sm shadow-sm">{{ userInitial }}</div>
          </div>

          <Transition name="fade">
            <div v-if="isProfileDropdownOpen" class="profile-dropdown-menu mobile-dropdown glass-panel shadow-lg rounded-4 overflow-hidden position-absolute mt-2 top-100 style-dropdown" @click.stop>
              <router-link :to="user?.role === 'admin' ? '/admin' : '/dashboard'" class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-theme-base hover-gold border-bottom border-light border-opacity-10 text-decoration-none" @click="closeProfileDropdown; closeMenu()">
                <LayoutDashboard size="18" /> <span class="fw-bold">لوحة التحكم</span>
              </router-link>
              <router-link to="/dashboard/profile" class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-theme-base hover-gold border-bottom border-light border-opacity-10 text-decoration-none" @click="closeProfileDropdown; closeMenu()">
                <UserIcon size="18" /> <span class="fw-bold">الملف الشخصي</span>
              </router-link>
              <button class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-danger hover-bg-danger text-start w-100 border-0 bg-transparent" @click="handleLogout">
                <LogOut size="18" /> <span class="fw-bold">تسجيل الخروج</span>
              </button>
            </div>
          </Transition>
        </div>

        <button class="theme-toggle-btn shadow-sm me-2 d-flex align-items-center justify-content-center" @click="toggleTheme" title="تبديل المظهر">
          <Sun v-if="isDarkMode" size="20" class="text-gold" />
          <Moon v-else size="20" class="text-gold" />
        </button>

        <button class="menu-toggle-btn shadow-sm" @click="toggleMenu">
          <Menu v-if="!menuOpen" size="24" />
          <X v-else size="24" />
        </button>
      </div>

      <Teleport to="body">
        <Transition name="fade">
          <div v-if="menuOpen" class="modern-backdrop" @click="closeMenu"></div>
        </Transition>
      </Teleport>

      <Teleport to="body">
        <div class="modern-sidebar" :class="{ 'is-open': menuOpen }" dir="rtl">
          <div class="sidebar-header-modern">
            <img src="@/assets/images/logo.png" alt="Logo" class="sidebar-logo-img"/>
            <button class="close-sidebar-btn" @click="closeMenu">
              <X size="24" />
            </button>
          </div>

          <div class="sidebar-content">
            <nav class="nav-menu">
              <router-link
                  v-for="item in navItems"
                  :key="item.to"
                  :to="item.to"
                  class="nav-card"
                  @click="closeMenu"
              >
                <div class="icon-box">
                  <component :is="item.icon" size="20" />
                </div>
                <span class="fw-bold">{{ item.label }}</span>
              </router-link>

            </nav>
          </div>

          <div class="sidebar-footer">
            <div v-if="isAuthenticated" class="user-card-modern position-relative" style="flex-direction: column; align-items: stretch; background: transparent;">
              <div class="d-flex align-items-center gap-3 transition-all profile-pill-hover rounded-4 p-2" @click.stop="toggleProfileDropdown" style="width: 100%;">
                <div class="user-avatar-box">
                  <img v-if="userAvatar" :src="userAvatar" />
                  <div v-else class="letter-avatar">{{ userInitial }}</div>
                </div>
                <div class="user-details text-truncate me-auto">
                  <p class="user-name text-truncate text-theme-base">{{ user?.name }}</p>
                  <span class="user-status text-gold fw-bold">حسابي</span>
                </div>
                <ChevronDown size="18" class="ms-auto text-theme-base dropdown-chevron" :class="{'is-open': isProfileDropdownOpen}" />
              </div>
              
              <Transition name="fade">
                <div v-if="isProfileDropdownOpen" class="mt-3 style-dropdown rounded-4 overflow-hidden w-100 border border-gold border-opacity-25" @click.stop>
                  <router-link :to="user?.role === 'admin' ? '/admin' : '/dashboard'" class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-theme-base text-decoration-none transition-all hover-gold" @click="closeMenu">
                    <LayoutDashboard size="18" class="text-gold" /> <span class="fw-bold fs-6">لوحة التحكم</span>
                  </router-link>
                  <router-link to="/dashboard/profile" class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-theme-base text-decoration-none transition-all hover-gold border-top border-light border-opacity-10" @click="closeMenu">
                    <UserIcon size="18" class="text-gold" /> <span class="fw-bold fs-6">الملف الشخصي</span>
                  </router-link>
                  <button class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-danger w-100 border-0 text-start transition-all hover-bg-danger border-top border-light border-opacity-10" style="background-color: transparent;" @click="handleLogout">
                    <LogOut size="18" /> <span class="fw-bold fs-6">تسجيل الخروج</span>
                  </button>
                </div>
              </Transition>
            </div>

            <router-link v-else to="/login" class="btn-login-modern shadow-sm" @click="closeMenu">
              <LogIn size="20" />
              <span>تسجيل الدخول</span>
            </router-link>
          </div>
        </div>
      </Teleport>

      <div class="collapse navbar-collapse d-none d-lg-block">
        <ul class="navbar-nav mx-auto nav-links gap-2">
          <li class="nav-item animate-nav-item" v-for="(item, index) in navItems" :key="item.to" :style="`--item-index: ${index}`">
            <router-link
                class="nav-link px-3 py-2 rounded-pill nav-hover-color"
                :to="item.to"
                active-class="active-nav-link"
            >
              {{ item.label }}
            </router-link>
          </li>
        </ul>

        <div class="nav-auth-section d-none d-lg-flex align-items-center gap-3">
          <button class="theme-toggle-btn shadow-sm d-flex align-items-center justify-content-center" @click="toggleTheme" title="تبديل المظهر">
            <Sun v-if="isDarkMode" size="20" class="text-gold" />
            <Moon v-else size="20" class="text-gold" />
          </button>
          
          <template v-if="isAuthenticated">
            <div class="notification-nav-wrapper position-relative me-2">
            <button class="notification-trigger-btn shadow-sm" @click.stop="toggleNotifications" title="التنبيهات">
              <Bell size="20" :class="{'text-gold': unreadCount > 0, 'animate-bell': unreadCount > 0}" />
              <span v-if="unreadCount > 0" class="notification-badge pulsate-badge">{{ unreadCount }}</span>
            </button>

            <Transition name="fade">
              <div v-if="isNotificationsOpen" class="notifications-dropdown glass-panel shadow-lg rounded-4 overflow-hidden position-absolute mt-3 border border-gold border-opacity-25" style="width: 320px; left: 0;" @click.stop>
                <div class="px-3 py-3 border-bottom border-light border-opacity-10 d-flex justify-content-between align-items-center bg-theme-soft">
                  <span class="fw-bold text-theme-base">التنبيهات</span>
                  <button v-if="unreadCount > 0" class="btn btn-link btn-sm text-gold text-decoration-none p-0" @click="markAllAsRead">تحديد الكل كمقروء</button>
                </div>
                <div class="notifications-list" style="max-height: 350px; overflow-y: auto;">
                  <div v-if="notifications.length === 0" class="p-4 text-center text-theme-muted">
                    <BellOff size="32" class="opacity-25 mb-2" />
                    <p class="m-0 small">لا توجد تنبيهات حالياً</p>
                  </div>
                  <div v-for="notif in notifications" :key="notif.id" 
                       class="notification-item p-3 border-bottom border-light border-opacity-10 transition-all cursor-pointer"
                       :class="{'unread-notif': !notif.isRead}"
                       @click="handleNotificationClick(notif)">
                    <div class="d-flex gap-2">
                      <div class="notif-icon-circle" :class="notif.type || 'info'">
                        <Info size="14" v-if="notif.type === 'info'" />
                        <CheckCircle size="14" v-else-if="notif.type === 'success'" />
                        <AlertTriangle size="14" v-else />
                      </div>
                      <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-start mb-1">
                          <h6 class="m-0 small fw-bold text-theme-base">{{ notif.title }}</h6>
                          <span class="x-small text-theme-muted">{{ formatDate(notif.createdAt) }}</span>
                        </div>
                        <p class="m-0 x-small text-theme-muted text-truncate-2">{{ notif.message }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <router-link to="/dashboard/notifications" class="d-block text-center py-2 x-small text-gold bg-dark bg-opacity-10 hover-glass text-decoration-none" @click="isNotificationsOpen = false"> عرض كل التنبيهات </router-link>
              </div>
            </Transition>
          </div>

          <div v-if="isAuthenticated" class="user-profile-nav position-relative">
            <div class="d-flex align-items-center gap-2 py-1 px-2 rounded-pill profile-pill-hover transition-all" @click.stop="toggleProfileDropdown">
              <span class="text-theme-base small fw-bold d-none d-xl-inline ps-2">{{ user?.name }}</span>
              <div v-if="userAvatar" class="avatar-img-wrapper shadow-sm">
                <img :src="userAvatar" class="nav-avatar" />
              </div>
              <div v-else class="avatar-letter-wrapper shadow-sm">{{ userInitial }}</div>
              <ChevronDown size="18" class="ms-1 text-gold d-none d-xl-block dropdown-chevron" :class="{'is-open': isProfileDropdownOpen}" />
            </div>
            
            <Transition name="fade">
              <div v-if="isProfileDropdownOpen" class="profile-dropdown-menu desktop-dropdown glass-panel shadow-lg rounded-4 overflow-hidden position-absolute mt-3 border border-gold border-opacity-25 dropdown-theme" style="width: 240px; left: 0;" @click.stop>
                <div class="px-4 py-3 border-bottom border-light border-opacity-10 header-gradient text-center">
                  <div class="fw-bold text-theme-base text-truncate">{{ user?.name }}</div>
                  <div class="small text-theme-muted text-truncate font-monospace" dir="ltr">{{ user?.email }}</div>
                </div>
                <router-link :to="user?.role === 'admin' ? '/admin' : '/dashboard'" class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-theme-base hover-gold border-bottom border-light border-opacity-10 text-decoration-none transition-all" @click="closeProfileDropdown">
                  <LayoutDashboard size="18" class="text-gold opacity-75" /> <span class="fw-bold fs-6">لوحة التحكم</span>
                </router-link>
                <router-link to="/dashboard/profile" class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-theme-base hover-gold border-bottom border-light border-opacity-10 text-decoration-none transition-all" @click="closeProfileDropdown">
                  <UserIcon size="18" class="text-gold opacity-75" /> <span class="fw-bold fs-6">الملف الشخصي</span>
                </router-link>
                <button class="dropdown-item d-flex align-items-center gap-3 py-3 px-4 text-danger w-100 border-0 bg-transparent text-start transition-all hover-bg-danger" @click="handleLogout">
                  <LogOut size="18" /> <span class="fw-bold fs-6">تسجيل الخروج</span>
                </button>
              </div>
            </Transition>
          </div>
          </template>

          <router-link v-else to="/login" class="btn login-btn fw-bold d-flex align-items-center justify-content-center gap-2 rounded-pill px-4">
            <LogIn size="18" />
            <span>تسجيل الدخول</span>
          </router-link>
        </div>
      </div>
    </div>
    
    <!-- Profile Backdrop Teleported to body so it sits behind the Navbar -->
    <Teleport to="body">
      <Transition name="fade">
        <div v-if="isProfileDropdownOpen" class="modern-backdrop position-fixed inset-0 z-dropdown-bg" @click.stop="closeProfileDropdown" style="background: var(--backdrop-bg);"></div>
      </Transition>
    </Teleport>
  </nav>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { LogIn, Menu, X, Home, BookOpen, Video, Users, MessageSquare, ChevronLeft, LogOut, User as UserIcon, LayoutDashboard, ChevronDown, Sun, Moon, Bell, BellOff, Info, CheckCircle, AlertTriangle } from 'lucide-vue-next';
import { useTheme } from '@/composables/useTheme';

const store = useStore();
const router = useRouter();
const { isDarkMode, toggleTheme } = useTheme();

const isAuthenticated = computed(() => store.getters["auth/isAuthenticated"]);
const user = computed(() => store.getters["auth/getUser"]);

const userInitial = computed(() => {
  if (user.value && user.value.name) {
    return user.value.name.charAt(0).toUpperCase();
  }
  return "?";
});

const userAvatar = computed(() => {
  if (!user.value?.avatar) return null;
  if (user.value.avatar.startsWith('http')) return user.value.avatar;
  const baseUrl = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:5000';
  return `${baseUrl}${user.value.avatar}`;
});

const isProfileDropdownOpen = ref(false);

const toggleProfileDropdown = (event) => {
  event.stopPropagation();
  isProfileDropdownOpen.value = !isProfileDropdownOpen.value;
};

const closeProfileDropdown = () => {
  isProfileDropdownOpen.value = false;
};

// Notification Logic
const isNotificationsOpen = ref(false);
const notifications = computed(() => store.state.notifications.notifications);
const unreadCount = computed(() => store.state.notifications.unreadCount);

const toggleNotifications = (event) => {
  event.stopPropagation();
  isNotificationsOpen.value = !isNotificationsOpen.value;
  if (isNotificationsOpen.value) {
    isProfileDropdownOpen.value = false;
  }
};

const closeNotifications = () => {
    isNotificationsOpen.value = false;
};

const markAllAsRead = () => {
    store.dispatch('notifications/markAllAsRead');
};

const handleNotificationClick = (notif) => {
    if (!notif.isRead) {
        store.dispatch('notifications/markAsRead', notif.id);
    }
    if (notif.link) {
        router.push(notif.link);
    }
    closeNotifications();
};

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('ar-SA', { month: 'short', day: 'numeric' });
};

const handleLogout = async () => {
  await store.dispatch('auth/logout');
  router.push('/');
  closeProfileDropdown();
  closeMenu();
};

onMounted(() => {
  document.addEventListener('click', () => {
      closeProfileDropdown();
      closeNotifications();
  });
});

onUnmounted(() => {
  document.removeEventListener('click', () => {
      closeProfileDropdown();
      closeNotifications();
  });
});

const goToDashboard = () => {
  router.push(user.value?.role === 'admin' ? '/admin' : '/dashboard');
  closeMenu();
  closeProfileDropdown();
};

const navItems = [
  { label: "الرئيسية", to: "/", icon: Home },
  { label: "القرآن الكريم", to: "/quran-karim", icon: BookOpen },
  { label: "الفيديوهات", to: "/videos", icon: Video },
  { label: "مركز الرحيمة", to: "/alrehima-center", icon: Users },
  { label: "من نحن", to: "/about-us", icon: Info },
  { label: "تواصل معنا", to: "/contact-us", icon: MessageSquare },
];

const menuOpen = ref(false);
const toggleMenu = () => (menuOpen.value = !menuOpen.value);
const closeMenu = () => (menuOpen.value = false);

watch(menuOpen, (val) => {
  if (val) {
    document.body.classList.add('mobile-menu-active');
  } else {
    document.body.classList.remove('mobile-menu-active');
  }
});

onUnmounted(() => {
  document.body.classList.remove('mobile-menu-active');
});
</script>

<style scoped>
:root {
  --primary-purple: #1f1a43;
  --accent-gold: #FFD700;
  --glass-bg: rgba(255, 255, 255, 0.05);
}

/* --- Navbar Core --- */
.luxury-navbar {
  background: var(--nav-bg);
  border-bottom: 2px solid rgba(255, 215, 0, 0.2);
  padding: 12px 0;
  z-index: 1000;
}

.nav-logo {
  width: 60px;
  transition: transform 0.3s ease;
}
.nav-logo:hover { transform: scale(1.05); }

/* --- Navigation Links --- */
.premium-nav-link {
  color: var(--text-color) !important;
  font-weight: 600;
  padding: 8px 16px;
  position: relative;
  transition: all 0.3s ease;
  opacity: 0.9;
}

.nav-hover-color {
  color: var(--text-color) !important;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent !important;
}

.nav-hover-color:hover:not(.active-nav-link) {
  color: var(--accent-gold) !important;
  transform: translateY(-2px);
  background: transparent !important;
}

/* Active Class Styling */
.active-nav-link {
  color: var(--accent-gold) !important;
  background: rgba(255, 215, 0, 0.1) !important;
  border-radius: 100px !important;
  font-weight: 700;
  box-shadow: inset 0 0 10px rgba(255, 215, 0, 0.05);
}

.active-nav-link:hover {
  background: rgba(255, 215, 0, 0.18) !important; /* Decreased transparency (more opaque) on hover */
  transform: translateY(-2px);
}

/* --- Enhanced Login Button --- */
.login-btn {
  background: transparent;
  color: var(--accent-gold) !important;
  border: 2px solid var(--accent-gold);
  padding: 10px 24px!important;
  border-radius: 100px!important;
  font-weight: 700;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

.login-btn:hover {
  background: var(--accent-gold);
  color: #1a1a2e !important;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(255, 215, 0, 0.3);
}

.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
  );
  transition: all 0.6s;
}

.login-btn:hover::before {
  left: 100%;
}

/* --- Profile Enhancements --- */
.profile-pill-hover {
  cursor: pointer;
  transition: background 0.3s ease;
}

.profile-pill-hover:hover {
  background: rgba(255, 255, 255, 0.1);
}

.nav-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.avatar-letter-wrapper {
  width: 38px;
  height: 38px;
  background: var(--accent-gold);
  color: #1f1a43;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* --- Mobile View & Toggle --- */
.theme-toggle-btn {
  background: var(--glass-panel);
  border: 1px solid var(--border-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.3s ease;
}
.theme-toggle-btn:hover { background: rgba(255, 215, 0, 0.2); color: #FFD700; }

.menu-toggle-btn {
  background: var(--glass-panel);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.3s;
}
.menu-toggle-btn:hover { background: var(--border-color); color: #FFD700; }

.modern-sidebar {
  position: fixed;
  top: 0;
  right: -320px;
  width: 300px;
  height: 100dvh;
  background: var(--nav-bg);
  z-index: 2000;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  border-left: 1px solid var(--border-color);
}

.modern-sidebar.is-open { right: 0; }

.modern-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1500;
}

.sidebar-header-modern {
  padding: 2rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-logo-img { width: 50px; }

.close-sidebar-btn {
  background: var(--glass-panel);
  border: 1px solid var(--border-color);
  color: var(--text-color);
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.close-sidebar-btn:hover {
  background: rgba(255, 215, 0, 0.2);
  color: var(--accent-gold);
}

.sidebar-content {
  flex: 1;
  padding: 0 1.2rem;
  overflow-y: auto;
}

.nav-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 14px 18px;
  margin-bottom: 10px;
  text-decoration: none;
  color: var(--text-color);
  opacity: 0.8;
  border-radius: 16px;
  background: var(--glass-panel);
  transition: 0.3s;
}

.nav-card:hover, .nav-card.router-link-active {
  background: var(--accent-gold);
  color: #0b061d !important;
  opacity: 1;
}

.icon-box {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--glass-panel);
  border-radius: 12px;
  color: inherit;
}

.nav-card.router-link-active .icon-box {
  background: #1f1a43;
  color: var(--accent-gold);
}



.sidebar-footer {
  padding: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.user-card-modern {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 18px;
  cursor: pointer;
  color: var(--text-color);
}

.user-avatar-box img, .letter-avatar {
  width: 45px;
  height: 45px;
  border-radius: 12px;
  object-fit: cover;
}

.letter-avatar {
  background: var(--accent-gold);
  color: #1f1a43;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.user-name { font-size: 0.95rem; font-weight: 700; margin: 0; }
.user-status { font-size: 0.8rem; color: rgba(255,255,255,0.5); }

.btn-login-modern {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%) !important;
  color: #1f1a43 !important;
  text-decoration: none;
  border-radius: 100px;
  font-weight: 700;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  border: none;
}
.btn-login-modern:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 8px 25px rgba(255, 215, 0, 0.4);
}

.avatar-circle-sm, .avatar-letter-sm {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.avatar-letter-sm {
  background: white;
  color: #1f1a43;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* Transitions */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* --- Dropdowns --- */
.z-dropdown-bg {
  z-index: 990;
}
.style-dropdown {
  min-width: 220px;
  background: var(--glass-panel) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  z-index: 2000;
}
.mobile-dropdown {
  position: absolute;
  top: 50px;
  left: 0;
  right: auto;
}
.desktop-dropdown {
  background: var(--glass-panel) !important;
  box-shadow: 0 15px 35px rgba(0,0,0,0.15);
  transform-origin: top left;
  border: 1px solid var(--border-color) !important;
}
.hover-gold {
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
}
.hover-gold:hover {
  background: linear-gradient(90deg, transparent, rgba(255, 215, 0, 0.1)) !important;
  color: var(--accent-gold) !important;
  padding-right: 30px !important;
}
.hover-gold:hover::before {
  content: '';
  position: absolute;
  right: 0; top: 0; bottom: 0;
  width: 4px;
  background: var(--accent-gold);
  border-radius: 4px 0 0 4px;
}
.hover-bg-danger {
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
}
.hover-bg-danger:hover {
  background: linear-gradient(90deg, transparent, rgba(220, 53, 69, 0.1)) !important;
  color: #ff6b6b !important;
  padding-right: 30px !important;
}
.hover-bg-danger:hover::before {
  content: '';
  position: absolute;
  right: 0; top: 0; bottom: 0;
  width: 4px;
  background: #ff6b6b;
  border-radius: 4px 0 0 4px;
}
.rotate-180 {
  transform: rotate(180deg);
}
.transition-all {
  transition: all 0.3s ease;
}
.hover-glass:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* --- Chevron Animation --- */
.dropdown-chevron {
  opacity: 0;
  transform: translateY(-5px) scale(0.8);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  margin-right: -10px; /* Offset to keep avatar centered when arrow is hidden */
}
.dropdown-chevron.is-open {
  opacity: 1;
  transform: translateY(0) scale(1) rotate(180deg);
  margin-right: 0;
}

.text-theme-base {
  color: var(--text-color) !important;
}

.text-theme-muted {
  color: var(--text-muted) !important;
}

/* Fix dropdown explicit colors in light mode */
.dropdown-theme {
    background: rgba(17, 10, 31, 0.75) !important;
    backdrop-filter: blur(25px) saturate(200%);
    -webkit-backdrop-filter: blur(25px) saturate(200%);
    border: 1px solid rgba(255, 215, 0, 0.25) !important;
    box-shadow: 0 20px 50px rgba(0,0,0,0.6), inset 0 0 20px rgba(255, 215, 0, 0.05);
}
.header-gradient {
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.15) 0%, transparent 100%);
    border-bottom: 1px solid rgba(255, 215, 0, 0.15) !important;
}
.dropdown-theme .border-light {
    border-color: rgba(255, 215, 0, 0.1) !important;
}

/* --- Professional Entry Animations --- */
.animate-nav-entry {
  animation: navSlideDown 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.animate-nav-item {
  opacity: 0;
  animation: navItemFadeIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(0.1s * var(--item-index) + 0.3s);
}

@keyframes navSlideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes navItemFadeIn {
  from {
    transform: translateY(-15px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

@media (max-width: 991px) {
    .animate-nav-item {
        animation: none;
        opacity: 1;
    }
}

/* Notification Styles */
.notification-trigger-btn {
  background: var(--glass-panel);
  border: 1px solid var(--border-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-trigger-btn:hover {
  background: rgba(255, 215, 0, 0.1);
  border-color: var(--accent-gold);
}

.notification-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #ff4d4d;
  color: white;
  font-size: 10px;
  font-weight: bold;
  height: 18px;
  min-width: 18px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid var(--nav-bg);
}

.notifications-dropdown {
  background: var(--nav-bg) !important;
  z-index: 1050;
  top: 100%;
}

.notification-item {
  transition: 0.2s;
}

.notification-item:hover {
  background: var(--glass-panel);
}

.unread-notif {
  background: rgba(255, 215, 0, 0.03);
}

.notif-icon-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.notif-icon-circle.info { background: rgba(0, 123, 255, 0.1); color: #007bff; }
.notif-icon-circle.success { background: rgba(40, 167, 69, 0.1); color: #28a745; }
.notif-icon-circle.warning { background: rgba(255, 193, 7, 0.1); color: #ffc107; }

.x-small { font-size: 0.7rem; }
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}

.animate-bell {
  animation: bellRing 2s ease infinite;
}

@keyframes bellRing {
  0% { transform: rotate(0); }
  10% { transform: rotate(15deg); }
  20% { transform: rotate(-10deg); }
  30% { transform: rotate(5deg); }
  40% { transform: rotate(-5deg); }
  50% { transform: rotate(0); }
  100% { transform: rotate(0); }
}

.pulsate-badge {
  animation: pulseBadge 2s infinite;
}

@keyframes pulseBadge {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 77, 77, 0.7); }
  70% { transform: scale(1.1); box-shadow: 0 0 0 10px rgba(255, 77, 77, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 77, 77, 0); }
}
</style>